import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { actionShowModal } from '../actions/modal';
import { ModalTypes } from '../reducers/modal';

export const LS_APP_VERSION = 'kattana-simple.app-version';

type hashType = string | null | undefined;

// hash from `env` - first param
// hash in local storage - second param
const isHashDiff = (versionA: hashType, versionB: hashType) => {
  if (versionA && versionA) {
    return versionA !== versionB;
  } else {
    return true;
  }
};

const useCacheBuster = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    if (window.localStorage) {
      // eslint-disable-next-line no-undef
      const latestCommitHash = process.env.REACT_APP_COMMIT_HASH;
      // eslint-disable-next-line no-prototype-builtins
      if (localStorage.hasOwnProperty(LS_APP_VERSION)) {
        const previousCommitHash = window.localStorage.getItem(LS_APP_VERSION);
        const shouldRefresh = isHashDiff(latestCommitHash, previousCommitHash);
        if (shouldRefresh) {
          console.log(
            `We have a new version - ${latestCommitHash}. Should force refresh`
          );
          dispatch(actionShowModal(ModalTypes.updateApp, {}));
        } else {
          console.log(
            `You already have the latest version - ${latestCommitHash}. No cache refresh needed.`
          );
        }
      } else {
        window.localStorage.setItem(LS_APP_VERSION, latestCommitHash || '');
      }
    }
  }, [dispatch]);
};

export default useCacheBuster;
